import React from "react";
import { Toaster } from "sonner";

import { ITEM_PROCESS_HIGHLIGHT_DURATION_MS } from "../lib/helpers";

export const AppToastContainer: React.FC = () => {
  const [theme, setTheme] = React.useState<"light" | "dark">(
    document.documentElement.dataset.theme === "dark" ? "dark" : "light",
  );

  React.useEffect(() => {
    const observer = new MutationObserver(() => {
      setTheme(document.documentElement.dataset.theme === "dark" ? "dark" : "light");
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => observer.disconnect();
  }, []);

  return (
    <Toaster
      position="bottom-right"
      theme={theme}
      richColors
      closeButton
      toastOptions={{ duration: ITEM_PROCESS_HIGHLIGHT_DURATION_MS }}
    />
  );
};
